<template>
  <div class="main">
    <TabListCon></TabListCon>
      <img src="../../../src/static/imgs/qywh.jpg" class="img" />
      <img src="../../../src/static/imgs/qywh6.jpg" class="img" />
      <template>
        <div class="box" v-if="videoShow">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="false" :options="playerOptions" />
        </div>
        <div class="box" v-else>
          <img src="../../static/imgs/MP4fm.jpg" class="video-player vjs-custom-skin" style="width: 100%;height: 100%;"></img>   
        </div>
      </template>
      <img src="../../../src/static/imgs/qywh1.jpg" class="img"></img>
      <img src="../../../src/static/imgs/qywh2.jpg" class="img"></img>
      <img src="../../../src/static/imgs/qywh4.jpg" class="img"></img>
      <img src="../../../src/static/imgs/qywh5.jpg" class="img"></img>
      <audio ref="audio" src="https://macj.oss-cn-hangzhou.aliyuncs.com/ztq.MP3" autoplay loop preload="auto"></audio>
    <BottomContentCon></BottomContentCon>
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
import { agentApply } from "@/utils/api";//调接口引入
import ImagePreloader from '../../components/Preload/index.js'
export default {
  name: "CorporateCulture",
  data() {
    return {
      videoShow: false,
      preloader: null,          
      videoPauseShow: true,
      playFlag: true,
      clickMusicBtn: false,
      playerOptions: {
        disablePictureInPicture: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",// 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "https://macj.oss-cn-hangzhou.aliyuncs.com/b92f73ac1f14c3871af6892d6f77498b_raw.mp4" // url地址
        }],
        poster: require("../../static/imgs/bj.png"), // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false  // 全屏按钮
        }
      }
    }
  },
  components: { TabListCon, BottomContentCon },
  created() {

  },
  beforeDestroy() {
      if (this.preloader) {
          console.log('进来没222防泄漏')
          this.preloader.destroy();
      }
  },   
  mounted() {
      this.audioAutoPlay()
      document.addEventListener("visibilitychange", (e) => { // 兼容ios微信手Q
        if (this.clickMusicBtn) { // 点击了关闭音乐按钮
          if (this.playFlag) {
            this.audioAutoPlay();
            this.playFlag = true;
          } else {
            this.audioPause();
            this.playFlag = false;
          }
      
          text.innerHTML = e.hidden;
          if (e.hidden) {  // 网页被挂起
            this.audioAutoPlay();
            this.playFlag = true;
          } else { // 网页被呼起
            this.audioPause();
            this.playFlag = false;
          }
        } else { // 未点击关闭音乐按钮
          if (this.playFlag) {
            this.audioPause();
            this.playFlag = false;
          } else {
            this.audioAutoPlay();
            this.playFlag = true;
          }
      
          text.innerHTML = e.hidden;
          if (e.hidden) {  // 网页被挂起
            this.audioPause();
            this.playFlag = false;
          } else { // 网页被呼起
            this.audioAutoPlay();
            this.playFlag = true;
          }
        }
      });
      this.preloader = new ImagePreloader();
        this.preloader.checkAllImagesLoaded(() => {
        console.log('所有图片加载完成');
        this.videoShow = true;
      });
  },
  methods: {
    handlePause() {
      this.videoPauseShow = true;
    },
    handlePlay() {
      //点击盒子让播放按钮隐藏
      this.videoPauseShow = false;
      //触发video的播放事件
      this.$refs.videoPlayer.play();
    },
      audioPlayOrPause() {
        this.clickMusicBtn = !this.clickMusicBtn;
        if (this.playFlag) {
          this.audioPause();
          this.playFlag = false;
        } else {
          this.audioAutoPlay();
          this.playFlag = true;
        }
      },
      audioPause() {
        let audio = this.$refs.audio
        audio.pause();
        document.addEventListener("WeixinJSBridgeReady", function () {
          audio.pause();
        }, false);
      },
      audioAutoPlay() {
        let audio = this.$refs.audio
        audio.play();
        document.addEventListener("WeixinJSBridgeReady", function () {
          audio.play();
        }, false);
      }, 
  }
};
</script>
<style scoped>
.box {
  width: 1287px;
  height: 709px;
  position: absolute;
  top: 1620px;
  left: 316.5px;
}
.boxs {
  width: 1552px;
  height: 858px;
  position: absolute;
  top: 5000px;
  left: 200px;
}
.img {
  width: 100%;
}
/deep/.vjs-has-started .vjs-control-bar {
  display: none;
}

.viveoMain {
  width: 100%;
  height: 100%;
}

.playBtn {
  width: 180px;
  height: 160px;
  display: block;
  position: absolute;
  margin-top: 320px;
  margin-left: 750px;
  z-index: 9998;
}

video::--webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none !important;
}

video::-webkit-media-controls-fullscreen-button {
  display: none;
}

video::-webkit-media-controls-play-button {
  display: none;
}

video::-webkit-media-controls-timeline {
  display: none;
}

video::-webkit-media-controls-current-time-display {
  display: none;
}

video::-webkit-media-controls-time-remaining-display {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

video::-webkit-media-controls-enclosure {
  display: none;
}

</style>